/**
 * Parses an encoded checkout response and returns checkout response data
 */
export function decodeCheckoutResponse(token?: string) {
  if (typeof token !== 'string') {
    return null;
  }

  const base64Payload = token.split('.')[1];

  if (typeof base64Payload !== 'string') {
    return null;
  }

  const jsonPayload = decodeURIComponent(
    window
      .atob(base64Payload.replace(/-/g, '+').replace(/_/g, '/'))
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  let parsedJsonResponse;
  try {
    parsedJsonResponse = JSON.parse(jsonPayload);
  } catch (err) {
    throw err;
  }

  return parsedJsonResponse;
}

/**
 * Checks if encoded checkout response has pending events
 */
export function hasPendingEvents(token?: string) {
  const decodedPutIntentResponse = decodeCheckoutResponse(token);
  const pendingEventsArr = decodedPutIntentResponse?.maskedCard?.digitalCardData?.pendingEvents;
  return Array.isArray(pendingEventsArr) && pendingEventsArr.length > 0;
}
